interface MemberLevelTagProps {
  level: string | number;
  className?: string;
}

const levelStyles: Record<string, string> = {
  '0': 'bg-[#CAD8FC]',
  '1': 'bg-[#B2CEF0]',
  '2': 'bg-[#F7BD9E]',
  '3': 'bg-gradient-to-r from-[#C693FF] to-[#CBEAFF]',
};

const MemberLevelTag: React.FC<MemberLevelTagProps> = ({ level, className }) => {
  const bgStyle = levelStyles[level] || levelStyles['0'];

  return (
    <span className={`inline-block rounded px-1.5 py-0.5 text-xs ${bgStyle} ${className}`}>
      V{level}
    </span>
  );
};

export default MemberLevelTag;
